import { g as getParentNode } from './getParentNode-R596COVt.js';
import { i as isScrollParent } from './isScrollParent-C6IhePsZ.js';
import { g as getNodeName } from './getNodeName-B4zdFol3.js';
import { b as isHTMLElement } from './instanceOf-DT24G-dX.js';

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

export { getScrollParent as g };
//# sourceMappingURL=getScrollParent-BqWwgY1z.js.map
